export default __webpack_public_path__ + "img/preview-10.6d32acf4.jpg";